module.exports = __webpack_public_path__ + "img/cardMain.9f34b37e.svg";